import styled from "styled-components"

export const CardWrap = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  
  max-width: 320px;
  height: max-content;
  border: 1px solid #D6D6D6;
  cursor: pointer;

  &:hover {
    border: 1px solid #5A5FF2;
    background: #F8F8FF;
  }

  ${props => props.isSelected && `
    border: 1px solid #5A5FF2;
    background: #F8F8FF;
  `}

  transition: all 0.2s ease-out;

  ${props => props.isLoading && `
    // height: 140px;
    // animation: glowBlink 1s forwards infinite;
    cursor: not-allowed;
  `}

  @keyframes glowBlink {
    0% {
      background: white;
    }

    100% {
      background: #F8F8FF;
    }
  }
`

export const AgentName = styled.div`
  p {
    overflow: hidden;
    color: #6E7093;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const Topic = styled.div`
  p {
    color: var(--BG-Dark-mode, #292A37);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%; /* 21.6px */
  }
`

export const Since = styled.div`
  p {
    color: #6E7093;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 13.353px; /* 111.275% */
  }
`

export const TimeAndFeedback = styled.div`

  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;

  p {
    text-align: justify;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

export const FeedBack = styled.div`
  .green {
    color: #00B255;
  }

  .red {
    color: #F87171;
  }

  img {
    width: 12.8px;
    height: 12.8px;
  }
`

export const ThumbsAndNumber = styled.div`
  display: flex;
  gap: 5px; 
`

export const Feedback = styled.div`

  display: flex;
  gap: 5px;

  p {
    margin: 0;
    text-align: justify;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: ${props => props.color};
  }

  img {
    width: 12.8px;
    height: 12.8px;
    flex-shrink: 0;
  }
`
